exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n[data-component='my-cpf'] {\n  position: absolute;\n  width: 230px;\n  text-align: center;\n  top: 170px;\n  left: 150%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n@media only screen and (max-width: 991px) {\n  [data-component='my-cpf'] {\n    width: 80%;\n  }\n}\n[data-component='my-cpf'] label {\n  text-align: left;\n}\n[data-component='my-cpf'] .btn-send {\n  margin: 60px 0 30px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/my-cpf/my-cpf.component.styl
// module id = ../../../../../src/app/autentication/my-cpf/my-cpf.component.styl
// module chunks = main